import { Entypo } from "@expo/vector-icons";
import dayjs from "dayjs";
import { EventSearchDetails } from "queries/ticket.queries";
import React from "react";
import { Pressable, Text, View } from "react-native";

interface EventListProps {
  events?: EventSearchDetails[];
  onEventPress: (event: EventSearchDetails) => void;
  loading?: boolean;
  emptyMessage?: string;
  onCategoryPress: (categoryName: string) => void;
  onVenuePress: (venue: string) => void;
}

const EventList: React.FC<EventListProps> = ({
  events,
  onEventPress,
  loading = false,
  emptyMessage = "No events found",
  onCategoryPress,
  onVenuePress,
}) => {
  if (loading) {
    return (
      <View className="flex-1 items-center justify-center py-8">
        <div className="text-gray-500">Loading events...</div>
      </View>
    );
  }

  if (!events) {
    return null;
  }

  if (events.length === 0) {
    return (
      <View className="flex-1 items-center justify-center py-8">
        <div className="text-gray-500">{emptyMessage}</div>
      </View>
    );
  }

  return (
    <View className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {events.map((event) => (
        <Pressable
          key={event.eventId}
          className="mb-3 px-2 bg-white rounded-lg overflow-hidden shadow"
          onPress={() => onEventPress(event)}
        >
          {/* Event Details */}
          <View className="p-3">
            {/* Title */}
            <Text className="font-bold text-lg mb-1">{event.title}</Text>

            {/* Date and Time - more compact */}
            <View className="flex-row items-center mb-1">
              <Entypo name="calendar" size={12} color="#8F9BB3" />
              <Text className="text-sm text-gray-600 ml-1">
                {dayjs(event.localDateTime).format("YYYY-MM-DD hh:mm A")}
              </Text>
            </View>
            <View className="flex-row items-center mb-1">
              <Entypo name="location-pin" size={12} color="#8F9BB3" />
              <Text
                onPress={() => onVenuePress(event.venueName)}
                className="text-sm text-blue-600 ml-1"
                numberOfLines={1}
              >{`${event.venueName} - ${event.venueCity}, ${event.venueState}`}</Text>
            </View>

            {/* Category */}
            <View className="flex-row items-center">
              <Entypo name="price-tag" size={12} color="#8F9BB3" />
              <Text
                className="text-sm text-blue-600 ml-1"
                onPress={() => onCategoryPress(event.categoryName)}
              >
                {event.categoryName}
              </Text>
            </View>
          </View>
        </Pressable>
      ))}
    </View>
  );
};

export default EventList;
